import { createApp } from 'vue';
import BookmarkButton from '../components/BookmarkButton.vue';
import ToastPlugin from 'vue-toast-notification';

document.addEventListener('DOMContentLoaded', () => {
    const mountElements = document.querySelectorAll('.bookmark-button-app');

    mountElements.forEach(element => {
        const productID = parseInt(element.dataset.productId);
        const productTitle = element.dataset.productTitle || '';
        const productCode = element.dataset.productCode || '';
        const apiUrl = element.dataset.apiUrl;
        const specsUrl = element.dataset.specsUrl || '';
        const variants = element.dataset.variants
            ? JSON.parse(element.dataset.variants)
            : [];
        const bundles = element.dataset.bundles
            ? JSON.parse(element.dataset.bundles)
            : [];
        const translations = element.dataset.translations
            ? JSON.parse(element.dataset.translations)
            : {};
        const accessories = element.dataset.accessories
            ? JSON.parse(element.dataset.accessories)
            : {};
        const accessoriesTranslations = element.dataset.accessoriesTranslations
            ? JSON.parse(element.dataset.accessoriesTranslations)
            : {};
        const imageFit = element.dataset.imageFit || '970x678';
        const imageOptimizeFormat = element.dataset.imageOptimizeFormat === '1';

        const app = createApp(BookmarkButton, {
            productID,
            productTitle,
            productCode,
            variants,
            bundles,
            accessories,
            apiUrl,
            specsUrl,
            translations,
            accessoriesTranslations,
            imageFit,
            imageOptimizeFormat,
        });

        app.use(ToastPlugin);
        app.mount(element);
    });
});
